import React from 'react';

const SlideFour = () => {
	return <div>SlideFour</div>;
};

export default SlideFour;
